import React from 'react'
import Image from './img/dealmed-image2.webp'
import './content.scss'

export default function EmeraldEverythingYouNeedSection() {
  return (
    <div className="eynioa">
      <div className="container">
        <div className="eynioa__titles">
          <h2 className="eynioa__title">Everything you need In one account.</h2>
          <p className="eynioa__desc">
            Create a Dealmed Runtime™ account to access a world of savings, strategy, updates and
            consultative resources.
          </p>

          <a href="/register" className="home-btn home-btn--grey home-btn--small">
            JOIN FREE
          </a>
        </div>
      </div>

      <div className="eynioa__image">
        <img src={Image} alt="" loading="lazy" />
      </div>
    </div>
  )
}
